/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DealTypeEnum } from './DealTypeEnum';
import {
    DealTypeEnumFromJSON,
    DealTypeEnumFromJSONTyped,
    DealTypeEnumToJSON,
} from './DealTypeEnum';
import type { RedemptionDeal } from './RedemptionDeal';
import {
    RedemptionDealFromJSON,
    RedemptionDealFromJSONTyped,
    RedemptionDealToJSON,
} from './RedemptionDeal';

/**
 * 
 * @export
 * @interface RedeemDealRewardDeal
 */
export interface RedeemDealRewardDeal {
    /**
     * 
     * @type {number}
     * @memberof RedeemDealRewardDeal
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof RedeemDealRewardDeal
     */
    readonly name: string;
    /**
     * 
     * @type {DealTypeEnum}
     * @memberof RedeemDealRewardDeal
     */
    readonly type: DealTypeEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof RedeemDealRewardDeal
     */
    readonly includes_alcohol: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedeemDealRewardDeal
     */
    readonly is_archived: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RedeemDealRewardDeal
     */
    readonly is_active: boolean;
    /**
     * Determines when this deal will be active next, based on the business's timezone.
     * @type {string}
     * @memberof RedeemDealRewardDeal
     */
    readonly next_active: string | null;
}

/**
 * Check if a given object implements the RedeemDealRewardDeal interface.
 */
export function instanceOfRedeemDealRewardDeal(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "includes_alcohol" in value;
    isInstance = isInstance && "is_archived" in value;
    isInstance = isInstance && "is_active" in value;
    isInstance = isInstance && "next_active" in value;

    return isInstance;
}

export function RedeemDealRewardDealFromJSON(json: any): RedeemDealRewardDeal {
    return RedeemDealRewardDealFromJSONTyped(json, false);
}

export function RedeemDealRewardDealFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedeemDealRewardDeal {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'type': DealTypeEnumFromJSON(json['type']),
        'includes_alcohol': json['includes_alcohol'],
        'is_archived': json['is_archived'],
        'is_active': json['is_active'],
        'next_active': json['next_active'],
    };
}

export function RedeemDealRewardDealToJSON(value?: RedeemDealRewardDeal | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

